export const GetProductActionTypes = {
    GET_PRODUCTS_REQUEST: "GET_PRODUCTS_REQUEST",
    GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
    GET_PRODUCTS_FAILURE: "GET_PRODUCTS_FAILURE",
    GET_PRODUCT_BY_ID_SUCCESS:'GET_PRODUCT_BY_ID_SUCCESS',
    GET_PRODUCT_BY_ID_REQUEST:'GET_PRODUCT_BY_ID_REQUEST',
    GET_PRODUCT_BY_ID_FAILURE:'GET_PRODUCT_BY_ID_FAILURE'

};
